import React from "react";
import IdentityPapersForm from "./IdentityPapersForm";

interface IdentityPapersProps {
  form: any;
}

const IdentityPapersData = ({ form }: IdentityPapersProps) => {
  return (
    <div className="takaful--recipient-container">
      <IdentityPapersForm form={form} />
    </div>
  );
};

export default IdentityPapersData;
